import React from "react";

export type ExternalRegisterSecureDetailsModalState = {
  open: boolean;
  patientId: string | null;
  alertId: string | null;
};

const CLOSED_STATE: ExternalRegisterSecureDetailsModalState = {
  open: false,
  patientId: null,
  alertId: null,
};

export const useExternalRegisterSecureDetailsModalState = () => {
  const [state, setState] = React.useState<ExternalRegisterSecureDetailsModalState>(CLOSED_STATE);

  const openDetails = React.useCallback((patientId: string, alertId?: string) => {
    setState({
      open: true,
      patientId,
      alertId: alertId ?? null,
    });
  }, []);

  const closeDetails = React.useCallback(() => {
    setState(CLOSED_STATE);
  }, []);

  return {
    detailsModalState: state,
    openExternalRegisterDetails: openDetails,
    closeExternalRegisterDetails: closeDetails,
  };
};
